import React, { createContext, useState, useEffect, useContext } from 'react';
import axiosInstance from '@libs/axiosInstance';

export const AnalyticsContext = createContext();

export const AnalyticsProvider = ({ children }) => {
  const [analytics, setAnalytics] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const response = await axiosInstance.get('/analytics/analytics/');
        setAnalytics(response.data);
      } catch (error) {
        console.error('Error fetching analytics:', error);
        setError('Failed to fetch analytics data.');
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, []);

  const incrementData = (key) => {
    setAnalytics((prevAnalytics) => ({
      ...prevAnalytics,
      [key]: prevAnalytics[key] + 1,
    }));
  };

  const decrementData = (key) => {
    setAnalytics((prevAnalytics) => ({
      ...prevAnalytics,
      [key]: prevAnalytics[key] - 1,
    }));
  };

  return (
    <AnalyticsContext.Provider value={{ analytics, loading, error, incrementData, decrementData }}>
      {loading ? (
        <div className="flex items-center justify-center h-screen">
          <span className="loading loading-dots loading-lg"></span>
        </div>
      ) : error ? (
        <div className="flex items-center justify-center h-screen">
          <p className="text-red-500">{error}</p>
        </div>
      ) : (
        children
      )}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = () => useContext(AnalyticsContext);
